const html = document.querySelector('html');
      header = document.querySelector('.l-header');
      hamburger = document.querySelector('.l-header__hamburger');
      headerSpAccordionArray = [...document.querySelectorAll('.js-header-sp-accordion-target')];
      headerLinks = [...document.querySelectorAll('.l-header__menu-container a[href]')];
      headerButtons = [...document.querySelectorAll('.l-header__button-group a[href]')];
      headerMenuCloseButton = document.querySelector('.l-header__menu-close');
      bookNowButton = document.querySelector('.js-book-now-open');
      bookNowCloseButton = document.querySelector('.l-header__reserve-close');
      headerPcMenu = document.querySelectorAll('.l-header__pc-menu a');
      overLay = document.querySelector('.l-header__overlay');

overLay.style.top = header.clientHeight;


// メガメニュー内のaタグをクリックしたらメガメニュー非表示
headerLinks.forEach((e) => {
  e.addEventListener('click', () => {
    menuClose();
  });
});
// pc時のheaderメニューのaタグをクリックしたらメガメニュー非表示
headerPcMenu.forEach((e) => {
  e.addEventListener('click', () => {
    menuClose();
  });
});
headerButtons.forEach((e) => {
  e.addEventListener('click', () => {
    menuClose();
  });
});

headerSpAccordionArray.forEach((e) => {
  e.addEventListener('click', () => {
    e.parentElement.classList.toggle('is-open-accordion');
  })
})

hamburger.addEventListener('click', () => {
  if(header.classList.contains('is-book-now-open')){
    header.classList.remove('is-book-now-open');
    header.classList.toggle('is-open');
  } else {
    header.classList.toggle('is-open');
    html.classList.toggle('u-hidden');
  }
});
headerMenuCloseButton.addEventListener('click', () => {
  menuToggle();
  overLay.style.display = 'block';
});

bookNowButton.addEventListener('click', () => {
  if(header.classList.contains('is-open')) {
    header.classList.remove('is-open');
    header.classList.toggle('is-book-now-open');
  } else {
    header.classList.toggle('is-book-now-open');
    html.classList.toggle('u-hidden');
  }
});

bookNowCloseButton.addEventListener('click', () => {
  header.classList.remove('is-book-now-open');
  html.classList.remove('u-hidden');
})

function menuToggle() {
  header.classList.toggle('is-open');
  html.classList.toggle('u-hidden');
}
function menuClose() {
  header.classList.remove('is-open');
  html.classList.remove('u-hidden');
}


// headerを監視する。　headerにクラス名が付与されたらoverlayを表示させるように
const observer = new MutationObserver(records => {
  if(header.classList.contains('is-open') || header.classList.contains('is-book-now-open')){
    overLay.style.display = 'block';
  } else {
    overLay.style.display = 'none';
  }
})
observer.observe(header, {
  attributes: true,
  attributeFilter: ['class']
})

const mediaQueryList = window.matchMedia('(min-width: 769px)');

window.addEventListener('DOMContentLoaded', ()=>{
  if(mediaQueryList.matches){
    header.style.top = `-${header.clientHeight}px`;
    window.addEventListener('scroll', () => {
      const scrollValue = window.pageYOffset;
      if (scrollValue < 78) {
        header.style.top = `-${header.clientHeight}px`;
      } else {
        header.style.opacity = 1;
        header.style.top = '0px';
      }
    });
  }
})

const listener = (event) => {
  if (event.matches) {
    
    window.addEventListener('scroll', () => {
      const scrollValue = window.pageYOffset;
      if (scrollValue < 78) {
        header.style.top = `-${header.clientHeight}px`;
      } else {
        header.style.top = '0px';
        header.style.opacity = 1;
      }
    });
  } else {
    header.style.top = '0px';
  }
};
mediaQueryList.addEventListener('change', listener);

// 多言語
let globalFormTab = [...document.querySelectorAll('.l-header-reserve__radio-group:not(:lang(ja)) .l-header__reserve-radio-label')];

globalFormTab.forEach((tab) => {
  tab.addEventListener('click', () => {
    classRemove(globalFormTab);
    tab.classList.add('is-current');
  })
})

function classRemove(element){
  element.forEach((form) => {
    form.classList.remove('is-current');
  })
}